import { Directive, Output, HostListener, EventEmitter } from '@angular/core';
import { Config } from '../universal-config';
import { Store } from '@ngrx/store';
import { IAppState } from '../app.state';
import { openLoginDialog } from '../login/login.actions';

@Directive({
  selector: '[clickLogin]'
})
export class ClickLoginDirective {
  constructor(
    public _config: Config,
    public _store: Store<IAppState>
  ) {
  }

  @HostListener('click', ['$event'])
  onClick(event) {
    this._store.dispatch(openLoginDialog());
  }
}
